import { render } from "./AdminRoles.vue?vue&type=template&id=55bc5531&scoped=true"
import script from "./AdminRoles.vue?vue&type=script&lang=js"
export * from "./AdminRoles.vue?vue&type=script&lang=js"

import "./AdminRoles.vue?vue&type=style&index=0&id=55bc5531&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bc5531"]])

export default __exports__